import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, UpdateFlinksDialogueHandler } from './types';
import UpdateFlinksCpmtext from './UpdateFlinksContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type FlinksDialogueProps = {
  handleDialogue: DialogueHandler<UpdateFlinksDialogueHandler>;
};

type FC = FunctionComponent<FlinksDialogueProps>;

const UpdateFlinksDialogue: FC = ({ handleDialogue }: FlinksDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, UpdateError } = useContext(UpdateFlinksCpmtext);
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Flinks.Update.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title={t('UpdateError.title')}
          status="error"
          subTitle={`${UpdateError}`}
          confirm={{
            label: t('UpdateError.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title={t('UpdateSuccess.title')}
          status="success"
          subTitle={t('UpdateSuccess.subTitle')}
          confirm={{
            label: t('UpdateSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert],
  );
};

export default UpdateFlinksDialogue;
